// extracted by mini-css-extract-plugin
module.exports = {"checkList":"checkList-module--checkList--3e_L8"};